// extracted by mini-css-extract-plugin
export const atlasGrotesk = "'AtlasGrotesk'";
export const bold = "700";
export const filters = "LinkedAccounts__filters__32Si4";
export const headBgColorExternal = "var(--salt)";
export const headBgColorInternal = "var(--shade)";
export const headBgColorShrunkSidebar = "var(--slate)";
export const header = "LinkedAccounts__header__GzlWA";
export const linkedAccountList = "LinkedAccounts__linkedAccountList__puyXm";
export const linkedAccountListItem = "LinkedAccounts__linkedAccountListItem__HKe-n";
export const linkedAccounts = "LinkedAccounts__linkedAccounts__tAYLt";
export const medium = "500";
export const regular = "400";
export const sans = "'sans'";
export const selectedFilter = "LinkedAccounts__selectedFilter__3pTd6";
export const semibold = "600";
export const serif = "'serif'";
export const subtitle = "LinkedAccounts__subtitle__uSLho";